import { OutlinedInput, OutlinedInputProps } from './outlined-input';

export const QuestionInput = (props: OutlinedInputProps) => (
  <OutlinedInput {...props} placeholder="Your question..." />
);
